// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__Ub5aq","checkboxContainer":"styles_checkboxContainer__E_FU7"};